import React from 'react';
import {
	IconWrapper,
	KpiSqaureGridContainer,
	Status,
	SummaryTitle,
} from '../Components.styles';
import { KpiElement } from '../KPIS/KpiElement';
import Tutorial from 'SpendController/Tutorial';
import { ApIcon, colors } from '@alixpartners/ui-components';
import { Tooltip } from 'react-tippy';
import { TooltipContent } from 'Waves/Waves.styles';

function Summary(props) {
	const {
		Fcolor,
		data,
		columns,
		rows,
		title,
		step,
		steps,
		isTutorialOpen,
		setIsTutorialOpen,
	} = props;
	return (
		<Status Fcolor={Fcolor}>
			{isTutorialOpen && (
				<Tutorial steps={steps} onClose={() => setIsTutorialOpen(false)} />
			)}
			<SummaryTitle>
				<div style={{ marginLeft: '10px' }}>{title}</div>
				{steps && (
					<Tooltip
						position="bottom"
						animation="fade"
						arrow
						html={<TooltipContent>Click to Play Tutorial</TooltipContent>}
						trigger="mouseenter"
					>
						<IconWrapper>
							<ApIcon
								iconName="baseline_help"
								iconSize="20px"
								outlined={true}
								iconColor={colors.green300}
								onClick={() => setIsTutorialOpen(true)}
							/>
						</IconWrapper>
					</Tooltip>
				)}
			</SummaryTitle>
			<KpiSqaureGridContainer columns={columns} rows={rows} height={`20%`}>
				{data.map(element => <KpiElement step={step} {...element} />)}
			</KpiSqaureGridContainer>
		</Status>
	);
}

export default Summary;
